import * as tslib_1 from "tslib";
import { default as FolderNode } from './FolderNode';
import { DRAG_X_OFFSET, DRAG_Y_OFFSET } from '../helpers/folderNodeDragConstants';
import { observer } from 'mobx-react';
import { shallowCompare } from 'office-ui-fabric-react/lib/Utilities';
import DragAndDroppable from 'owa-dnd/lib/components/DragAndDroppable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import folderStore from 'owa-folders';
import { getCustomIcon } from 'owa-mail-folder-forest-actions';
import { lazyMoveFolder } from 'owa-mail-folder-store';
import toggleFolderNodeExpansion from 'owa-mail-folder-store/lib/actions/toggleFolderNodeExpansion';
import getFolderViewStateFromId from 'owa-mail-folder-store/lib/selectors/getFolderViewStateFromId';
import { listViewStore } from 'owa-mail-list-store';
import { shouldDisplayFolderInFolderTree } from 'owa-folders';
import * as lazyTriageActions from 'owa-mail-triage-action';
import * as React from 'react';
var mailFolderNodeStyles = require('./MailFolderNode.scss');
var MailFolderNode = /** @class */ (function (_super) {
    tslib_1.__extends(MailFolderNode, _super);
    function MailFolderNode(props) {
        var _this = _super.call(this, props) || this;
        _this.onChevronClicked = function (evt) {
            evt.stopPropagation();
            toggleFolderNodeExpansion(_this.folder.FolderId.Id);
        };
        _this.renderDraggableMailFolderNode = function (textClassNames) {
            return React.createElement("span", { className: textClassNames }, _this.folder.DisplayName);
        };
        _this.onContextMenu = function (evt) {
            var onContextMenu = _this.props.onContextMenu;
            if (onContextMenu) {
                evt.stopPropagation();
                evt.preventDefault();
                onContextMenu(evt, _this.folder);
            }
        };
        _this.onDrop = function (dragData) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var itemType, _a, mailListItemPartDragData, tableView, moveItemsBasedOnNodeIds, mailListRowDragData, tableViewId, rowKeys, mailFolderItemBeingDragged, draggedFolderId;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        itemType = dragData.itemType;
                        _a = itemType;
                        switch (_a) {
                            case DraggableItemTypes.MailListItemPart: return [3 /*break*/, 1];
                            case DraggableItemTypes.MailListRow: return [3 /*break*/, 3];
                            case DraggableItemTypes.MultiMailListMessageRows: return [3 /*break*/, 3];
                            case DraggableItemTypes.MultiMailListConversationRows: return [3 /*break*/, 3];
                            case DraggableItemTypes.MailFolderNode: return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 5];
                    case 1:
                        mailListItemPartDragData = dragData;
                        tableView = listViewStore.tableViews.get(mailListItemPartDragData.tableViewId);
                        return [4 /*yield*/, lazyTriageActions.lazyMoveItemsBasedOnNodeIds.import()];
                    case 2:
                        moveItemsBasedOnNodeIds = _b.sent();
                        moveItemsBasedOnNodeIds(mailListItemPartDragData.nodeIds, this.props.folderId, tableView.id, 'Drag');
                        return [3 /*break*/, 5];
                    case 3:
                        {
                            mailListRowDragData = dragData;
                            tableViewId = mailListRowDragData.tableViewId;
                            rowKeys = mailListRowDragData.rowKeys;
                            lazyTriageActions.lazyMoveMailListRows.importAndExecute(rowKeys, this.props.folderId, tableViewId, 'Drag');
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        {
                            mailFolderItemBeingDragged = dragData;
                            draggedFolderId = mailFolderItemBeingDragged.folderId;
                            lazyMoveFolder.importAndExecute(this.props.folderId, draggedFolderId, this.props.treeType);
                        }
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.canDrop = function (dragData) {
            var itemType = dragData.itemType;
            switch (itemType) {
                case DraggableItemTypes.MailFolderNode:
                case DraggableItemTypes.MailListItemPart:
                case DraggableItemTypes.MailListRow:
                case DraggableItemTypes.MultiMailListMessageRows:
                case DraggableItemTypes.MultiMailListConversationRows:
                    return true;
                case DraggableItemTypes.FavoriteNode:
                default:
                    return false;
            }
        };
        _this.onDragOver = function (dragData) {
            _this.isDragOver = true;
            setTimeout(function () {
                if (_this.isDragOver) {
                    if (_this.isFolderExpandable(_this.folder) && !_this.folderViewState.isExpanded) {
                        toggleFolderNodeExpansion(_this.folder.FolderId.Id);
                    }
                }
            }, 500);
        };
        _this.onDragLeave = function () {
            _this.isDragOver = false;
        };
        _this.getDragData = function () {
            var folderNodeDragData = {
                itemType: DraggableItemTypes.MailFolderNode,
                folderId: _this.props.folderId,
                displayName: _this.folder.DisplayName,
                treeType: _this.props.treeType,
            };
            return folderNodeDragData;
        };
        _this.getDragPreview = function (folderNodeDragData) {
            var elem = document.createElement('div');
            elem.className = mailFolderNodeStyles.dragHelperStyle;
            elem.innerText = folderNodeDragData.displayName;
            return elem;
        };
        _this.isFolderExpandable = function (folder) {
            if (!folder.childFolderIds) {
                return false;
            }
            var visibleFolders = folder.childFolderIds.filter(function (childFolderId) {
                var childFolder = folderStore.folderTable.get(childFolderId);
                return shouldDisplayFolderInFolderTree(childFolder);
            });
            return visibleFolders.length > 0;
        };
        return _this;
    }
    Object.defineProperty(MailFolderNode.prototype, "folder", {
        get: function () {
            return folderStore.folderTable.get(this.props.folderId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailFolderNode.prototype, "folderViewState", {
        get: function () {
            return getFolderViewStateFromId(this.props.folderId);
        },
        enumerable: true,
        configurable: true
    });
    MailFolderNode.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !shallowCompare(this.props, nextProps);
    };
    MailFolderNode.prototype.render = function () {
        return (React.createElement(DragAndDroppable, { dragViewState: this.folderViewState.drag, getDragData: this.getDragData, getDragPreview: this.getDragPreview, xOffset: DRAG_X_OFFSET, yOffset: DRAG_Y_OFFSET, dropViewState: this.folderViewState.drop, onDrop: this.onDrop, canDrop: this.canDrop, onDragOver: this.onDragOver, onDragLeave: this.onDragLeave },
            React.createElement(FolderNode, { chevronProps: this.getChevronProps(this.folder), customIcon: getCustomIcon(this.props.folderId, false), depth: this.props.depth, displayName: this.folder.DisplayName, folderId: this.props.folderId, isDroppedOver: this.folderViewState.drop &&
                    this.folderViewState.drop.isDragOver &&
                    this.isDragOver, isBeingDragged: this.props.isBeingDragged, onContextMenu: this.onContextMenu, renderCustomTreeNodeDisplay: this.renderDraggableMailFolderNode, treeType: this.props.treeType, shouldHideToggleFavorite: this.props.shouldHideToggleFavorite, showHoverStateOnDroppedOver: true })));
    };
    MailFolderNode.prototype.getChevronProps = function (folder) {
        // Check if the node is expandable / should have chevrons
        if (this.isFolderExpandable(folder)) {
            return { isExpanded: this.folderViewState.isExpanded, onClick: this.onChevronClicked };
        }
        else {
            return null;
        }
    };
    MailFolderNode = tslib_1.__decorate([
        observer
    ], MailFolderNode);
    return MailFolderNode;
}(React.Component));
export default MailFolderNode;
//# sourceMappingURL=MailFolderNode.js.map